import { listStates } from '../thunks/states';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const statesReducers = (builder) => {
  // list property states
  builder
    .addCase(listStates.fulfilled, (state, action) => handleFulfilled(state, 'states', action))
    .addCase(listStates.pending, (state) => handlePending(state, 'states'))
    .addCase(listStates.rejected, (state) => handleRejected(state, 'states'));
};
